<script setup lang="ts">
import { darkTheme, dateZhCN, zhCN } from 'naive-ui'
import { useThemeStore } from './store/useTheme'

// import { NConfigProvider, darkTheme } from 'naive-ui';

const themeStore = useThemeStore()
const naiveDarkTheme = computed(() => (themeStore.darkMode ? darkTheme : undefined))
</script>

<template>
  <NConfigProvider
    :locale="zhCN" :date-locale="dateZhCN" class=" w-full" inline-theme-disabled :theme="naiveDarkTheme"
    :theme-overrides="themeStore.naiveTheme"
  >
    <AppProvider>
      <RouterView class=" bg-layout w-full min-h-100vh" />
    </AppProvider>
  </NConfigProvider>
</template>

<style scoped></style>
